import Component from '@glimmer/component'
import { service } from '@ember/service'
import { trackedFunction } from 'reactiveweb/function'
import { keepLatest } from 'reactiveweb/keep-latest'
import { use } from 'ember-resources'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import { TimeOnTaskUsage as UsageChart } from 'teacher-ui-client/components/giraffe/charts/time-on-task/usage'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import type { NormalizedInterval } from 'date-fns'
import type { UIScope } from 'teacher-ui-client/reporting/ui-scope/route'
import { NoDataMessage } from 'teacher-ui-client/components/no-data-message'
import { ErrorsUnexpected } from 'teacher-ui-client/components/errors/unexpected'
import FidgetSpinnerWaveComponent from '@blakeelearning/fidget/components/fidget/spinner/wave'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

interface Signature {
  Element: HTMLElement
  Args: {
    noContentClass?: string
    statsScope: StudentsScope
    period: NormalizedInterval
    uiScope: UIScope
  }
}

export class TimeOnTaskUsageWL extends Component<Signature> {
  @service studentEvents!: StudentEventsService

  fetchUsage = trackedFunction(this, () => {
    return this.studentEvents.timeOnTaskUsage('writing_legends', this.args.statsScope, this.args.period)
  })

  @use
  latestUsage = keepLatest({
    value: () => this.fetchUsage.value,
    when: () => this.fetchUsage.isPending,
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    {{#if this.latestUsage}}
      <UsageChart
        data-test-time-on-task-usage-chart
        class={{if this.fetchUsage.isPending "opacity-50"}}
        @data={{this.latestUsage}}
        @uiScope={{@uiScope}}
        @primaryTheme={{ThemeKeys.darkBlue}}
        @secondaryTheme={{ThemeKeys.darkOrange}}
        ...attributes
      />
    {{else if this.fetchUsage.isPending}}
      {{! initial load }}
      <div class={{@noContentClass}} data-test-usage-loading><FidgetSpinnerWaveComponent @centered={{true}} /></div>
    {{else if this.fetchUsage.isError}}
      <ErrorsUnexpected class={{@noContentClass}} data-test-usage-error />
    {{else}}
      <NoDataMessage class={{@noContentClass}} data-test-usage-empty />
    {{/if}}
  </template>
}
